import React, { useState, useEffect } from "react";
import GlobalFunctions from "../Services/GlobalFunctions";
import Swal from "sweetalert2";
import MakeDiscount from "./MakeDiscount";
import DialogoLoading from "../Components/DialogoLoading";
import DialogoMostrarTelefonos from "./DialogoMostrarTelefonos";
import TablaAmortizado from "./TablaAmortizado";
import "../App.css";
import DialogoChoosePhone from "./DialogoChoosePhone";
import DialogoAccionTelefono from "./DialogoAccionTelefono";

export default function DetalleCliente(params) {
  const glob = new GlobalFunctions();
  const [destinoSeleccionTelefono, setDestinoSeleccionTelefono] =
    useState(null);
  const [hideTotalPagar, setHideTotalPagar] = useState(false);
  const [telefonoSelected, setTelefonoSelected] = useState(null);

  useEffect(() => {
    if (params.cliente.cedula == "") {
      window.location.href = process.env.REACT_APP_MY_URL;
    }
  }, []);

  function seleccionarTelefono(telefono) {
    setTelefonoSelected(telefono);
    setTimeout(() => {
      document.getElementById("btnDialogoAccionTelefono").click();
    }, 100);
  }

  function setSizeText(id) {
    const text = document.getElementById(id);
    const letras = text.value;
    const size = Math.round(letras.length / 44);
    text.rows = size + 1;
  }

  function defaultSize(id) {
    document.getElementById(id).rows = "1";
  }

  function checkColorMora() {
    let color = "";
    if (
      params.cliente.prestamo != null &&
      parseInt(params.cliente.prestamo.cuotasenmora) > 0
    ) {
      color = "#c93c20";
    }
    return color;
  }

  function checkColorVencimiento() {
    let color = "";
    if (
      params.cliente.prestamo != null &&
      parseInt(params.cliente.prestamo.validarVencimiento) < 0
    ) {
      color = "#c93c20";
    }
    return color;
  }

  function validarSaldoAmort() {
    let textoSaldo = glob.formatNumber(params.cliente.prestamo.tt_saldo);
    if (params.cliente.prestamo.amortizado) {
      textoSaldo = "Ver en tabla";
    }
    return textoSaldo;
  }

  function compartirDescuento(descuento) {
    setDestinoSeleccionTelefono(descuento);
    document.getElementById("btnDialogoChoosePhone").click();
  }

  function compartirAbono(item) {
    let texto =
      "Cuota " +
      item.altura_cuota +
      " de " +
      params.cliente.prestamo.n_cuotas +
      " en total. Gracias por tu pago!";
    params.cliente.abonos.forEach((element) => {
      if (element.valor_abono != params.cliente.prestamo.valor_cuotas) {
        texto =
          "Aproximadamente cuota " +
          item.altura_cuota +
          " de " +
          params.cliente.prestamo.n_cuotas +
          " en total. ¡Gracias por tu pago!";
      }
    });
    setDestinoSeleccionTelefono(texto);
    document.getElementById("btnDialogoChoosePhone").click();
  }

  function choosePhone(phone) {
    let href =
      "https://api.whatsapp.com/send?phone=57" +
      phone +
      "&text=" +
      destinoSeleccionTelefono;
    window.open(
      href,
      "nuevo",
      "directories=no, location=no, menubar=no, scrollbars=yes, statusbar=no, tittlebar=no, width=800, height=600"
    );
  }

  function validarMostrarBotonDescuento() {
    let mostrar = "none";
    if (params.cliente.prestamo.valorprestamo != "") {
      if (params.cliente.prestamo.amortizado != true) {
        mostrar = "";
      }
    }
    return mostrar;
  }

  return (
    <div>
      <div className="table-responsive">
        <table style={{ marginTop: "0.2em" }} className="table table-sm">
          <thead>
            <tr className="align-middle">
              <th
                colSpan="4"
                style={{ backgroundColor: "#0061a9", color: "white" }}
                className="rounded navBarFondo"
              >
                Cliente. Copia del {glob.getCookie("fecha_copia")}
              </th>
            </tr>
            <tr className="align-middle">
              <th className="fondoCelda centerCelda rounded">Nombre</th>
              <th>{params.cliente.nombreCompleto}</th>
              <th className="fondoCelda centerCelda rounded">Dir trabajo</th>
              <th>
                <div>
                  <textarea
                    className="rounded"
                    readOnly
                    cols="26"
                    onMouseOut={() =>
                      defaultSize("dirtra" + params.cliente.cedula)
                    }
                    onMouseOver={() =>
                      setSizeText("dirtra" + params.cliente.cedula)
                    }
                    id={"dirtra" + params.cliente.cedula}
                    value={
                      params.cliente.direccion_trabajo == "" ||
                      params.cliente.direccion_trabajo == null
                        ? ""
                        : params.cliente.direccion_trabajo
                    }
                    rows="1"
                  ></textarea>
                </div>
              </th>
            </tr>
            <tr className="align-middle">
              <th className="fondoCelda centerCelda rounded">Cedula</th>
              <th>{params.cliente.cedula}</th>
              <th className="fondoCelda centerCelda rounded">Tel trabajo</th>
              <th>
                <div>
                  <textarea
                    className="rounded"
                    readOnly
                    cols="26"
                    onMouseOut={() =>
                      defaultSize("teltra" + params.cliente.cedula)
                    }
                    onMouseOver={() =>
                      setSizeText("teltra" + params.cliente.cedula)
                    }
                    id={"teltra" + params.cliente.cedula}
                    value={
                      params.cliente.telefono_trabajo == "" ||
                      params.cliente.telefono_trabajo == null
                        ? ""
                        : params.cliente.telefono_trabajo
                    }
                    rows="1"
                  ></textarea>
                </div>
              </th>
            </tr>
            <tr className="align-middle">
              <th className="fondoCelda centerCelda rounded">Dirección</th>
              <th>
                <div>
                  <textarea
                    className="rounded"
                    readOnly
                    cols="26"
                    onMouseOut={() =>
                      defaultSize("dir" + params.cliente.cedula)
                    }
                    onMouseOver={() =>
                      setSizeText("dir" + params.cliente.cedula)
                    }
                    id={"dir" + params.cliente.cedula}
                    value={params.cliente.direccion}
                    rows="1"
                  ></textarea>
                </div>
              </th>
              <th className="fondoCelda centerCelda rounded">Cartera</th>
              <th>{params.cliente.Cobro}</th>
            </tr>
            <tr className="align-middle">
              <th className="fondoCelda centerCelda rounded">Telefonos</th>
              <th>
                <div>
                  {params.cliente.telefonos.length > 2 ? (
                    <li>
                      {params.cliente.telefonos[0]}{" "}
                      <button
                        data-toggle="modal"
                        data-target="#dialogoMostrarTelefonos"
                        className="btn btn-link"
                      >
                        y otros...
                      </button>
                    </li>
                  ) : (
                    params.cliente.telefonos.map((item, index) => {
                      return (
                        <li
                          onClick={() => seleccionarTelefono(item)}
                          key={index}
                        >
                          {item}
                        </li>
                      );
                    })
                  )}
                </div>
              </th>
              <th className="fondoCelda centerCelda rounded">Comentarios</th>
              <th>
                <div>
                  <textarea
                    className="rounded"
                    readOnly
                    cols="26"
                    onMouseOut={() =>
                      defaultSize("otros" + params.cliente.cedula)
                    }
                    onMouseOver={() =>
                      setSizeText("otros" + params.cliente.cedula)
                    }
                    id={"otros" + params.cliente.cedula}
                    value={
                      params.cliente.otro_rifa == "" ||
                      params.cliente.otro_rifa == null
                        ? ""
                        : params.cliente.otro_rifa
                    }
                    rows="1"
                  ></textarea>
                </div>
              </th>
            </tr>
          </thead>
        </table>
      </div>
      {/* Tabla prestamo */}
      <div style={{ marginTop: "-0.6em" }} className="table-responsive ">
        <table className="table table-sm">
          <thead>
            <tr className="align-middle">
              <th
                colSpan="6"
                style={{ backgroundColor: "#0061a9", color: "white" }}
                className="rounded navBarFondo"
              >
                <span style={{ display: "flex" }}>
                  Crédito
                  <div
                    style={{
                      marginLeft: "0.6em",
                      color: hideTotalPagar ? "white" : "black",
                    }}
                    className="form-check form-switch "
                  >
                    <input
                      style={{
                        backgroundColor: hideTotalPagar ? "green" : "gray",
                      }}
                      className="form-check-input"
                      type="checkbox"
                      id="flexSwitchCheckDefault"
                      checked={hideTotalPagar}
                      onChange={() =>
                        setHideTotalPagar(hideTotalPagar ? false : true)
                      }
                    />
                  </div>
                </span>
              </th>
            </tr>
            <tr className="align-middle">
              <th className="fondoCelda centerCelda rounded">Fecha crédito</th>
              <th className="centerCelda">
                {params.cliente.prestamo.fecha_prest}
              </th>
              <th className="fondoCelda centerCelda rounded">Valor crédito</th>
              <th className="centerCelda">
                {params.cliente.prestamo.fecha_prest == ""
                  ? ""
                  : "$" +
                    glob.formatNumber(params.cliente.prestamo.valorprestamo)}
              </th>
              <th
                style={{ display: hideTotalPagar ? "" : "none" }}
                className="fondoCelda centerCelda rounded"
              >
                Tiempo (meses)
              </th>
              <th
                style={{ display: hideTotalPagar ? "" : "none" }}
                className="centerCelda"
              >
                {params.cliente.prestamo.tiempo_meses}
              </th>
            </tr>
            <tr className="align-middle">
              <th className="fondoCelda centerCelda rounded">Valor cuotas</th>
              <th className="centerCelda">
                {params.cliente.prestamo.valor_cuotas == null
                  ? ""
                  : "$" +
                    glob.formatNumber(params.cliente.prestamo.valor_cuotas)}
              </th>
              <th className="fondoCelda centerCelda rounded">N° cuotas</th>
              <th className="centerCelda">
                {params.cliente.prestamo.n_cuotas}
              </th>
              <th
                style={{ display: hideTotalPagar ? "" : "none" }}
                className="fondoCelda centerCelda rounded"
              >
                Costo servicio
              </th>
              <th
                style={{ display: hideTotalPagar ? "" : "none" }}
                className="centerCelda rounded"
              >
                {params.cliente.prestamo.interes == null
                  ? ""
                  : params.cliente.prestamo.interes + "%"}
              </th>
            </tr>
            <tr className="align-middle">
              <th className="fondoCelda centerCelda rounded">Cuotas en mora</th>
              <th
                className="rounded centerCelda"
                style={{
                  backgroundColor: checkColorMora(),
                }}
              >
                {params.cliente.prestamo.cuotasenmora == null
                  ? ""
                  : params.cliente.prestamo.cuotasenmora}
              </th>
              <th className="fondoCelda centerCelda rounded">Periodicidad</th>
              <th className="centerCelda">
                {params.cliente.prestamo.periodicidad == ""
                  ? ""
                  : params.cliente.prestamo.periodicidad}
              </th>
              <th
                style={{ display: hideTotalPagar ? "" : "none" }}
                className="fondoCelda centerCelda rounded"
              >
                Total a pagar
              </th>
              <th
                style={{ display: hideTotalPagar ? "" : "none" }}
                className="centerCelda rounded"
              >
                {params.cliente.prestamo.totalapagar == null
                  ? ""
                  : "$" +
                    glob.formatNumber(params.cliente.prestamo.totalapagar)}
              </th>
            </tr>
            <tr className="align-middle">
              <th className="fondoCelda centerCelda rounded">Vencimiento</th>
              <th
                className="rounded centerCelda"
                style={{
                  backgroundColor: checkColorVencimiento(),
                }}
              >
                {params.cliente.prestamo.vencimiento == null
                  ? ""
                  : params.cliente.prestamo.vencimiento}
              </th>
              <th className="fondoCelda centerCelda rounded">Saldo</th>
              <th className="centerCelda">
                {params.cliente.prestamo == null ? (
                  ""
                ) : (
                  <span
                    style={{
                      display: params.cliente.prestamo.amortizado ? "flex" : "",
                      color: "blue",
                    }}
                  >
                    {validarSaldoAmort()}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      className="bi bi-arrow-down"
                      viewBox="0 0 16 16"
                      style={{
                        display: params.cliente.prestamo.amortizado
                          ? ""
                          : "none",
                        marginTop: "0.8em",
                        marginLeft: "0.2em",
                      }}
                    >
                      <path
                        fillRule="evenodd"
                        d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1"
                      />
                    </svg>
                  </span>
                )}
              </th>
              <th
                style={{ display: hideTotalPagar ? "" : "none" }}
                className="fondoCelda centerCelda rounded"
              >
                Total abonos
              </th>
              <th
                style={{ display: hideTotalPagar ? "" : "none" }}
                className="centerCelda"
              >
                {params.cliente.prestamo.tt_abonos == ""
                  ? ""
                  : "$" + glob.formatNumber(params.cliente.prestamo.tt_abonos)}
              </th>
            </tr>
          </thead>
        </table>
      </div>
      {/* Tabla abonos */}
      <div style={{ marginTop: "-0.5em" }} className="table-responsive">
        <table className="table table-sm">
          <thead>
            <tr className="align-middle">
              <th
                colSpan="5"
                style={{ backgroundColor: "#0061a9", color: "white" }}
                className="rounded navBarFondo"
              >
                Abonos
              </th>
            </tr>
            <tr className="align-middle">
              <th className="fondoCelda centerCelda rounded">Fecha</th>
              <th className="fondoCelda centerCelda rounded">Cuota n°</th>
              <th className="fondoCelda centerCelda rounded">Abono</th>
              <th className="fondoCelda centerCelda rounded">Asesor</th>
              <th
                style={{
                  display:
                    params.prest != null &&
                    params.prest.validarVencimiento < -31
                      ? ""
                      : "none",
                }}
                className="fondoCelda centerCelda rounded"
              >
                Int mora
              </th>
              <th className="fondoCelda centerCelda rounded"></th>
            </tr>
          </thead>
          <tbody>
            {params.cliente.abonos.map((item) => {
              return (
                <tr
                  style={{
                    color: item.valor_abono < 0 ? "red" : "",
                  }}
                  key={item.id}
                  className="centerCelda"
                >
                  <th>{item.fecha}</th>
                  <td>{item.altura_cuota}</td>
                  <td>{glob.formatNumber(item.valor_abono)}</td>
                  <td>{item.asesor}</td>
                  <th
                    style={{
                      display:
                        params.prest != null &&
                        params.prest.validarVencimiento < -31
                          ? ""
                          : "none",
                    }}
                  >
                    {item.fecha_abono_interes}
                  </th>
                  <td className="d-flex justify-content-center">
                    {/*Compartir abono*/}
                    <button
                      onClick={() => compartirAbono(item)}
                      className="btn btn-outline-primary btn-sm"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-share"
                        viewBox="0 0 16 16"
                        style={{
                          color: "black",
                        }}
                      >
                        <path d="M13.5 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.5 2.5 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5m-8.5 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m11 5.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3" />
                      </svg>
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {/* Tabla acciones */}
      <div style={{ marginTop: "-0.5em" }} className="table-responsive">
        <table className="table table-sm">
          <thead>
            <tr className="align-middle">
              <th
                colSpan="5"
                style={{ backgroundColor: "#0061a9", color: "white" }}
                className="rounded navBarFondo"
              >
                Acciones
              </th>
            </tr>
            <tr className="align-middle">
              <th className="fondoCelda centerCelda rounded">
                <button
                  style={{
                    display: validarMostrarBotonDescuento(),
                    backgroundColor: "green",
                    color: "white",
                  }}
                  className="btn btn-sm"
                  type="button"
                  data-toggle="modal"
                  data-target="#discountModal"
                >
                  Calcular descuento
                </button>
                <button
                  data-toggle="modal"
                  data-target="#modalTableAmortizado"
                  style={{
                    display:
                      validarMostrarBotonDescuento() == "" ||
                      params.cliente.prestamo.valorprestamo == ""
                        ? "none"
                        : "",
                    backgroundColor: "#0d6efd",
                    color: "white",
                  }}
                  className="btn btn-sm"
                >
                  <span style={{ display: "flex" }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-table"
                      viewBox="0 0 16 16"
                      style={{ marginRight: "0.4em" }}
                    >
                      <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm15 2h-4v3h4zm0 4h-4v3h4zm0 4h-4v3h3a1 1 0 0 0 1-1zm-5 3v-3H6v3zm-5 0v-3H1v2a1 1 0 0 0 1 1zm-4-4h4V8H1zm0-4h4V4H1zm5-3v3h4V4zm4 4H6v3h4z" />
                    </svg>
                    Tabla amortizado
                  </span>
                </button>
              </th>
            </tr>
          </thead>
        </table>
      </div>
      <MakeDiscount
        cliente={params.cliente}
        prest={params.cliente.prestamo}
        compartirDescuento={compartirDescuento}
      ></MakeDiscount>
      <button
        id="btnModalLoading"
        type="button"
        style={{ display: "none" }}
        data-toggle="modal"
        data-target="#modalLoading"
      ></button>
      <DialogoChoosePhone
        choosePhone={choosePhone}
        telefonos={params.cliente.telefonos}
      ></DialogoChoosePhone>
      <DialogoAccionTelefono
        telefono={telefonoSelected}
      ></DialogoAccionTelefono>
      <DialogoMostrarTelefonos
        telefonos={params.cliente.telefonos}
        seleccionarTelefono={seleccionarTelefono}
      ></DialogoMostrarTelefonos>
      <TablaAmortizado
        abonos={
          params.cliente.abonos.length > 0
            ? params.cliente.abonosTablaAmortizado
            : []
        }
        cliente={params.cliente}
        prest={params.prest}
      ></TablaAmortizado>
    </div>
  );
}
